module.exports = "/circle_plus_secondary-815261dc78ea37fb16a15b81cdabc415.svg";